import {ModuleWithProviders, NgModule} from '@angular/core';
import {FilePondModule, registerPlugin} from 'ngx-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import {TranslocoModule} from '@ngneat/transloco';
import {SharedConfig} from 'shared/lib/shared.config.interface';
import {RouterModule} from '@angular/router';
import {CalculateEllipsisDirective, CalculateEllipsisDirectiveModule} from 'shared/lib/calculate-ellipsis/calculate-ellipsis.directive';
import {TextWithEllipsisComponent, TextWithEllipsisModule} from './text-with-ellipsis/text-with-ellipsis.component';
import {ScrollClassDirective, ScrollClassDirectiveModule} from 'shared/lib/scroll-class/scroll-class.directive';
import {UserBarComponent, UserBarModule} from 'shared/lib/user-bar/user-bar.component';
import {CommonModule} from '@angular/common';
import {ApplyThemeDirective, ApplyThemeDirectiveModule} from 'shared/lib/apply-theme/apply-theme.directive';
import {SharedConfigToken} from 'shared/lib/shared.config.token';
import {StructElementsModule} from 'shared/lib/struct-elements/struct-elements.module';
import {NgbDatepickerModule, NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {FileUploadModule} from 'shared/lib/file-upload/file-upload.module';
import {DateFormatPipe} from '../../../journal/src/_pipes/date-format.pipe';
import {IconSpritesModule} from 'shared/lib/icon-sprite/icon-sprite.component';
import {CalendarWithOverlayComponent, CalendarWithOverlayModule} from './calendar-with-overlay/calendar-with-overlay.component';
import {ReactiveFormsModule} from '@angular/forms';
import {DurationPipe} from '../../../journal/src/_pipes/duration.pipe';
import {FirstLetterUppercase} from '../../../journal/src/_pipes/first-letter-uppercase.pipe';
import {EllipsisComponent, EllipsisModule} from 'shared/lib/ellipsis/ellipsis.component';
import {FilterEmptyAndIgnoredFieldsPipe} from '../../../journal/src/lib/journal/entry/_pipes/filter-empty-fields.pipe';
import {FilterWarningsWithOther} from '../../../journal/src/lib/journal/entry/_pipes/filterWarningsWithOther.pipe';
import {ContentRenderComponent, ContentRenderModule} from '../../../journal/src/lib/journal/entry/content-render/content-render.component';
import {ImageLoadDirective, ImageLoadDirectiveModule} from './image-load.directive';
import {ObjectLength} from '../../../journal/src/_pipes/object-lenght.pipe';
import {DateRangePipe} from '../../../journal/src/_pipes/date-range.pipe';
import {HideByProfessionDirective, HideByProfessionDirectiveModule} from 'shared/lib/hide-by-profession/hide-by-profession.directive';
import {UserBarToggleComponent, UserBarToggleModule} from 'shared/lib/user-bar-toggle/user-bar-toggle.component';
import {ClickOutsideDirective, ClickOutsideDirectiveModule} from 'shared/lib/click-outside/click-outside.directive';

registerPlugin(FilePondPluginFileValidateType as any);
registerPlugin(FilePondPluginFileValidateSize);

@NgModule({
	declarations: [
		DurationPipe,
		DateFormatPipe,
		FirstLetterUppercase,
		FilterEmptyAndIgnoredFieldsPipe,
		FilterWarningsWithOther,
		ObjectLength,
		DateRangePipe
	],
	imports: [
		CommonModule,
		FilePondModule,
		TranslocoModule,
		RouterModule,
		StructElementsModule,
		NgbTooltipModule,
		FileUploadModule,
		IconSpritesModule,
		NgbDatepickerModule,
		ReactiveFormsModule,
		NgbDropdownModule,
		TextWithEllipsisModule,
		CalculateEllipsisDirectiveModule,
		ApplyThemeDirectiveModule,
		ScrollClassDirectiveModule,
		UserBarModule,
		UserBarToggleModule,
		ClickOutsideDirectiveModule,
		CalendarWithOverlayModule,
		EllipsisModule,
		ContentRenderModule,
		ImageLoadDirectiveModule,
		HideByProfessionDirectiveModule
	],
	providers: [],
	exports: [
		StructElementsModule,
		ApplyThemeDirective,
		CalculateEllipsisDirective,
		TextWithEllipsisComponent,
		ScrollClassDirective,
		UserBarComponent,
		FileUploadModule,
		DurationPipe,
		IconSpritesModule,
		CalendarWithOverlayComponent,
		DateFormatPipe,
		FirstLetterUppercase,
		EllipsisComponent,
		FilterEmptyAndIgnoredFieldsPipe,
		FilterWarningsWithOther,
		ContentRenderComponent,
		ImageLoadDirective,
		ObjectLength,
		DateRangePipe,
		HideByProfessionDirective,
		ApplyThemeDirective,
		ScrollClassDirective,
		UserBarComponent,
		UserBarToggleComponent,
		ClickOutsideDirective
	]
})
export class SharedModule {
	static forRoot(config: SharedConfig): ModuleWithProviders<SharedModule> {
		return {
			ngModule: SharedModule,
			providers: [
				{
					provide: SharedConfigToken,
					useValue: config
				}
			]
		};
	}
}
